<mat-form-field class="w-100 dense-2" appearance="outline">
  <mat-label>{{ label() }}</mat-label>
  <input
    matInput
    [matDatepicker]="picker"
    [formControl]="formControlRef()"
    [required]="required()"
    [min]="min()"
    [max]="max()"
  />
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-datepicker
    #picker
    startView="year"
    (monthSelected)="onMonthSelected($event, picker)"
  ></mat-datepicker>
</mat-form-field>
